import { CountiesResults } from '@/types/services/counties-list'
export function getCountiesFactory(res): CountiesResults {
return res
}
